import React from 'react'


export default function Footer() {

  return (
    <footer style={{position:'fixed', width:'100%', bottom:0}} className="py-4 bg-light mt-auto">
      <div style={{padding:0}} className="container-fluid justify-content-center">
        <div className="d-flex align-items-center justify-content-center small">
          <div className="text-muted">Copyright &copy; Achemed Codex {new Date().getFullYear()} </div>
        </div>
      </div>
    </footer>
  )
}
